module.exports = __webpack_public_path__ + "static/media/icon-request.bb1ac0ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-request.svg
// module id = 440
// module chunks = 11